export const AUTO_COMPLETE_LOADED = '@@mah-maps/AUTO_COMPLETE_LOADED';